<ng-container [formGroup]="qqcForm" *ngIf="isReady$ | async">
  <nibtravel-radio-group
    [radioGroup]="travellerConfig"
    (checked)="onTravellerNumbersChange($event)"
  ></nibtravel-radio-group>
  <fieldset
    id="traveller-age-fieldset"
    formArrayName="policyHolders"
    *transloco="let t; read: 'qqc.traveller-age'"
  >
    <legend class="legend-caption">{{ t('fieldset') }}</legend>
    <div class="input-age-group">
      <nibtravel-input
        *ngFor="let policyHolder of policyHolders?.controls; let i = index"
        class="qqc-age"
        inputId="traveller-age-{{ i }}"
        inputName="traveller-age-{{ i }}"
        [placeholder]="setAgePlaceholders(i)"
        [e2eId]="e2eId.TravellerAge(i)"
        [errorMessageOnFormGroup]="true"
        [validations]="ageValidations"
        [validationlabel]="'age'"
        [type]="'number'"
        [formControl]="policyHolder.get('age')"
        (error)="onError($event, i)"
      ></nibtravel-input>
    </div>
  </fieldset>
  <nibtravel-validation-handler
    [validations]="arrayValidations"
    [control]="policyHolders"
    [enableDistinctUntilChanged]="true"
    (validationResult)="onError($event, -1)"
  ></nibtravel-validation-handler>
  <ng-container *ngIf="errors$ | async as errors">
    <nibtravel-error-message
      id="traveller-age-errors"
      [errors]="errors"
      *ngIf="errors.length > 0"
    ></nibtravel-error-message>
  </ng-container>
</ng-container>
